/**
 * External dependencies
 */

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

/**
 * Internal dependencies
 */
import './styles.scss';

const FormNumberInput = (props) => {
    const classes = classNames('form-number-input', props.className, {
        'is-error': props.isError,
        'is-valid': props.isValid,
    });

    return <input type='number' {...props} className={classes} />;
};

FormNumberInput.propTypes = {
    isError: PropTypes.bool,
    isValid: PropTypes.bool,
    className: PropTypes.string,
};

export default FormNumberInput;
